var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGbFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 26H5.6875C2.54638 26 0 23.4536 0 20.3125V5.6875C0 2.54638 2.54638 0 5.6875 0H20.3125C23.4536 0 26 2.54638 26 5.6875V20.3125C26 23.4536 23.4536 26 20.3125 26Z",
    fill: "#0052B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0001 20.312V19.0635L21.9671 16.4212H26.0001V15.0527H15.0527V26.0001H16.4211V17.6953L25.1013 23.3823C25.4087 22.9037 25.6461 22.3758 25.7995 21.8134",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.382434 22.3664C0.520965 22.7239 0.694332 23.064 0.898777 23.3823L9.57892 17.6953V26.0001H10.9473V15.0527H0V16.4212H4.033L0 19.0635V20.3126C0 20.5313 0.0127969 20.7469 0.0368164 20.9592",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.88082V6.93662L4.033 9.57897H0V10.9474H10.9474V0H9.57897V8.30477L0.898777 2.61777C0.561437 3.143 0.308395 3.72745 0.158133 4.35195",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6102 3.61405C25.4729 3.26371 25.302 2.93023 25.1013 2.61772L16.4211 8.30477V0H15.0527V10.9474H26.0001V9.57897H21.9671L26.0001 6.93662V5.6875C26.0001 5.46102 25.9864 5.23768 25.9607 5.0181",
    fill: "#F5F5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0526 0H10.9474V10.9474H0V15.0526H10.9474V26H15.0526V15.0526H26V10.9474H15.0526V0Z",
    fill: "#D80027"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02768 16.4209L0.0366211 20.959C0.0921758 21.4497 0.209988 21.9214 0.382289 22.3661L9.54114 16.4209H7.02768V16.4209Z",
    fill: "#D80027"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4922 16.4209L25.7993 21.8132C25.9297 21.335 25.9998 20.8319 25.9998 20.3124V20.3118L20.0056 16.4209L17.4922 16.4209Z",
    fill: "#D80027"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21052 9.57858L0.158133 4.35156C0.0549961 4.77995 0 5.22708 0 5.68711V5.88043L5.69705 9.57858H8.21052Z",
    fill: "#D80027"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9343 9.57913L25.9604 5.01826C25.903 4.52852 25.7836 4.05778 25.6099 3.61426L16.4209 9.57913H18.9343Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbFlag);
export default __webpack_public_path__ + "static/media/GB_Flag.dd0e507c39eee2a35efaf3303f7b23d1.svg";
export { ForwardRef as ReactComponent };